import { render, staticRenderFns } from "./styleGuideIcons.vue?vue&type=template&id=4d72d6f6&scoped=true&"
import script from "./styleGuideIcons.vue?vue&type=script&lang=js&"
export * from "./styleGuideIcons.vue?vue&type=script&lang=js&"
import style0 from "./styleGuideIcons.vue?vue&type=style&index=0&id=4d72d6f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72d6f6",
  null
  
)

export default component.exports